const mealTypes = [
  {
    id: 1,
    name: 'Almoço',
    alias: 'lunch'
  },
  {
    id: 2,
    name: 'Jantar',
    alias: 'dinner'
  }
]

export default mealTypes
